import { render, staticRenderFns } from "./ReportedUserView.vue?vue&type=template&id=0e090c27&"
import script from "./ReportedUserView.vue?vue&type=script&lang=js&"
export * from "./ReportedUserView.vue?vue&type=script&lang=js&"
import style0 from "./ReportedUserView.vue?vue&type=style&index=0&id=0e090c27&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports